import * as api from '../api/index'

import { ADD_NEW_VENDOR, UPDATE_VENDOR, DELETE_VENDOR, FETCH_VENDORS_BY_USER, ALL_VENDORS, FETCH_VENDOR, START_LOADING, END_LOADING } from './constants'


export const getVendor = (id) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchVendor(id);
      dispatch({ type: FETCH_VENDOR, payload: { vendor: data } });

    } catch (error) {
      console.log(error);
    }
  };


export const getVendorsByUser =(searchQuery) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING })
      const  { data } = await api.fetchVendorsByUser(searchQuery)
      dispatch({ type: FETCH_VENDORS_BY_USER, payload: data.results });
      dispatch({ type: END_LOADING })
    } catch (error) {
      console.log(error.response)      
    }
  }

  export const getAllVendors =() => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING })
      const  { data } = await api.fetchVendors()
      dispatch({ type: ALL_VENDORS, payload: data.results });
      dispatch({ type: END_LOADING })
    } catch (error) {
      console.log(error.response)      
    }
  }


export const createVendor =(vendor, openSnackbar) => async (dispatch) => {

    try {
        const { data } = await api.addVendor(vendor)
        dispatch({ type: ADD_NEW_VENDOR, payload: data.data })
        openSnackbar("Vendor added successfully")

    } catch (error) {
        console.log(error)
    }
}


export const updateVendor =(id, vendor, openSnackbar) => async (dispatch) => {

    const { data } = await api.updateVendor(id, vendor)
      dispatch({ type: UPDATE_VENDOR, payload: data.data })
    openSnackbar("Vendor updated successfully")
    try {
        
    } catch (error) {
        console.log(error)
    }
}

export const deleteVendor =(id, openSnackbar) => async (dispatch) => {
    try {
        await api.deleteVendor(id)

        dispatch({type: DELETE_VENDOR, payload: id})
        openSnackbar("Vendor deleted successfully")
    } catch (error) {
        console.log(error)
    }
}